import { createContext, PropsWithChildren, useContext, useState } from 'react'

type ModalContextType = {
  isOpen: boolean
  open: (component: JSX.Element) => void
  close: () => void
  toggle: () => void
  modal: JSX.Element | null
}

export const ModalContext = createContext<ModalContextType>({
  isOpen: false,
  modal: null,
  open: () => {},
  close: () => {},
  toggle: () => {},
})

const ModalWrapper = () => {
  const { isOpen, modal } = useModal()
  return isOpen ? (
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        top: 0,
        left: 0,
        right: 0,
        zIndex: 998,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {modal}
    </div>
  ) : null
}

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modal, setModal] = useState<JSX.Element | null>(null)

  const open = (modal: JSX.Element | null) => {
    setModal(modal)
    setIsOpen(true)
  }

  const close = () => {
    setModal(null)
    setIsOpen(false)
  }

  const toggle = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen)
  }

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        close,
        open,
        modal,
        toggle,
      }}
    >
      <ModalWrapper />
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error("useModal deve essere usato all'interno di un ModalProvider")
  }
  return context
}
